import { v4 as uuidv4 } from 'uuid';
import { IPackage, IPublicationPackagesState } from '../types';

export const mergePublicationPackages = (
  state: IPublicationPackagesState,
  packagesList: IPackage[],
): IPublicationPackagesState => {
  if (!state.changedByUser) {
    return {
      packagesList: packagesList.map(pubPackage => ({
        ...pubPackage,
        id: uuidv4(),
      })),
      disabled: state.disabled,
      changedByUser: false,
    };
  }

  return state;
};
